import axios from 'axios'
import { ElMessage } from "element-plus";
import { outterMessage,  successCode } from "./status";
import router from '@/router'; // Import the router

interface ObjParams {
    [propName: string]: any
}
const axiosIns: ObjParams = axios.create({
    // baseURL: window.configs.BASE_URL,
    timeout: 300000,
    withCredentials: true // Set withCredentials to true
});

axiosIns.interceptors.response.use(
    (res: ObjParams) => {
        if (res) {
            console.log(res);
            const { code, message } = res.data;
            if (code === -3) {
                // Redirect to login page using router
                router.push('/login'); // Use router for navigation
            }
            return Promise.resolve(res.data);
        }
    },
    (error: ObjParams) => {
        const { status } = error.response;
        if (status === 200) {
            return;
        }
        const errTips: string = outterMessage(status);
        ElMessage.error(errTips);
        return Promise.reject(error);
    }
);

export default axiosIns;
